import { SVGProps } from 'react';

export function NewspaperIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M8 5H9M8 7H9M4 9H9M4 11H9M11 5H13.25C13.6642 5 14 5.33579 14 5.75V12C14 12.8284 13.3284 13.5 12.5 13.5M11 5V12C11 12.8284 11.6716 13.5 12.5 13.5M11 5V3.25C11 2.83579 10.6642 2.5 10.25 2.5H2.75C2.33579 2.5 2 2.83579 2 3.25V12C2 12.8284 2.67157 13.5 3.5 13.5H12.5M4 5H6V7H4V5Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
